'use strict'

import { apiInstance, legacyV2 } from './index'
import { mapArgs } from 'utils/functions'
import webCallMock from 'components/newWebCall/drawer/rideList/mock.json'
import webCallMock2 from 'components/newWebCall/drawer/rideList/mock2.json'

let webCallMockIndex = 0
const mock2 = false

const generic = {
  getWebCallEmployee (...args) {
    const params = mapArgs(...args)
    return apiInstance({
      method: 'GET',
      url: `${legacyV2()}/webcall/employee`,
      params
    })
  },

  getWebCallCostCenter (employeeId, ...args) {
    const params = mapArgs(...args)
    return apiInstance({
      method: 'GET',
      url: `${legacyV2()}/webcall/employee/${employeeId}/costcenters`,
      params
    })
  },

  getWebCallProjects (costCenterID, ...args) {
    const params = mapArgs(...args)
    return apiInstance({
      method: 'GET',
      url: `${legacyV2()}/webcall/costcenter/${costCenterID}/projects`,
      params
    })
  },

  getWebCallById (id) {
    return apiInstance({
      method: 'GET',
      url: `${legacyV2()}/webcall/${id}`
    })
  },

  getWebCallHistory (...args) {
    const params = mapArgs(...args)
    return apiInstance({
      method: 'GET',
      url: `${legacyV2()}/webcall`,
      params
    })
  },

  getWebCallHistoryMock (...args) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        let data = [...webCallMock2]

        if (!mock2) {
          const ride = webCallMock[webCallMockIndex]
          data = ride ? [{ ...ride }] : []
        }

        resolve({ data: { data } })
        webCallMockIndex++
      }, 1000)
    })
  },

  getWebCallCategory (employeeId, ...args) {
    /*
      params:
      fromLat: -23.5396263
      fromLng: -46.638325699999996
      toLat: -23.5459823
      toLng: -46.80989139999997
    */
    const params = mapArgs(...args)
    return apiInstance({
      method: 'GET',
      url: `${legacyV2()}/webcall/employee/${employeeId}/category`,
      params
    })
  },

  callCar (payload) {
    /**
    {
      "phoneNumber":"",
      "companyID":1,
      "employeeID":00001,
      "costCenterID":00001,
      "projectID":00001,
      "notes":"",
      "from":{
          "latitude":-23.5396263,
          "longitude":-46.638325699999996,
          "number":"",
          "street":""
      },
      "to":{
          "latitude":-23.5459823,
          "longitude":-46.80989139999997,
          "number":"",
          "street":""
      },
      "categoryID":"top99",
      "addressReference":"",
      "optionals":[]
    }
     */
    return apiInstance({
      method: 'POST',
      url: `${legacyV2()}/webcall`,
      data: { ...payload }
    })
  },

  cancelRide (rideId) {
    // payload = { "id":"TVRRME1URTFOekF6TVRZeE9ETTBPVFk0TlE9PQ==" } == rideID
    return apiInstance({
      method: 'PUT',
      url: `${legacyV2()}/webcall/${rideId}/cancel`,
      data: { id: rideId }
    })
  },

  removeNotification (rideId) {
    // rideId = TVRRME1URTFOekF6TVRZeE9ETTBPVFk0TlE9PQ==
    return apiInstance({
      method: 'DELETE',
      url: `${legacyV2()}/webcall/${rideId}/dismiss`
    })
  },

  getRideStatus (rideId) {
    // rideId = TVRRME1URTFOekF6TVRZeE9ETTBPVFk0TlE9PQ==
    const date = new Date().getTime()
    return apiInstance({
      method: 'GET',
      url: `${legacyV2()}/webcall/${rideId}?_=${date}`
    })
  },

  getWebCallCompanies () {
    return apiInstance({
      method: 'GET',
      url: `${legacyV2()}/webcall/company`
    })
  },

  getFavoriteAddress (userId) {
    return apiInstance({
      method: 'GET',
      url: `b2b-iam-app/favorites/${userId}`
    })
  },

  createFavoriteAddress (userId, data) {
    return apiInstance({
      method: 'POST',
      url: `b2b-iam-app/favorites/${userId}/add`,
      data
    })
  },

  removeFavoriteAddress (userId, data) {
    return apiInstance({
      method: 'DELETE',
      url: `b2b-iam-app/favorites/${userId}/remove`,
      data
    })
  }
}

export default generic
